import { render, staticRenderFns } from "./TableForm3.vue?vue&type=template&id=2c855368&scoped=true"
import script from "./TableForm3.vue?vue&type=script&lang=ts"
export * from "./TableForm3.vue?vue&type=script&lang=ts"
import style0 from "./TableForm3.vue?vue&type=style&index=0&id=2c855368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c855368",
  null
  
)

export default component.exports